import invariant from 'invariant';
import type { ReactNode } from 'react';

import { Box } from '#/components/Box/Box';
import type { MultiStepFormStepRow } from '#/components/Form/MultiStepForm/MultiStepFormTypes';
import { isDefined } from '#/utils/functional/type';

function SectionField({
  field,
  fields,
}: {
  field: string;
  fields: Record<string, ReactNode>;
}) {
  if (!field) {
    return null;
  }

  const f = fields[field];
  invariant(f, `Field with name '${field}' does not exist`);

  // oxlint-disable-next-line react/jsx-no-useless-fragment
  return <>{f}</>;
}

type Props = {
  row: MultiStepFormStepRow;
  fields: Record<string, ReactNode>;
  seenFields: Record<string, number>;
};

export function SectionFields({ row, fields, seenFields }: Props) {
  return (
    <Box display="flex" flexWrap="wrap" mx="-8px" width="calc(100% + 16px)">
      {row.fields.map((fieldName, fieldIndex, rowFields) => {
        const columns =
          // TODO: Fix this the next time the file is edited.
          // oxlint-disable-next-line no-nested-ternary
          row.noColumns
            ? 1
            : row && isDefined(row.columns)
              ? row.columns
              : rowFields.length;

        const fieldCount = seenFields[fieldName] || 0;

        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line no-param-reassign
        seenFields[fieldName] = fieldCount + 1;

        return (
          <Box
            key={fieldCount === 0 ? fieldName : `${fieldName}-${fieldCount}`}
            width={[1, null, null, 1 / columns]}
            px="8px"
            flex="0 0 auto"
          >
            <SectionField fields={fields} field={fieldName} />
          </Box>
        );
      })}
    </Box>
  );
}
